import { ROLES } from '@/constants/roles';

export const giftedChildren = {
  path: '/gifted-children',
  name: 'gifted-children',
  component: () => import('./views/GiftedChildren.vue'),
  meta: {
    title: 'Реестр одаренных детей',
    icon: 'mdi-emoticon-outline',
    accessList: [ROLES.operator, ROLES.department, ROLES.organization],
    instruction: {
      id: { [ROLES.operator]: 31, '*': 43 },
      name: 'Реестр одаренных детей',
    },
  },
};

export default [giftedChildren];
